import React, {useState} from 'react';
import axios from 'axios';
import {Button} from '@material-ui/core';
import {DropzoneArea} from 'material-ui-dropzone';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

const InsuranceScreen = () => {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  const handleFiles = (files: File[]) => {
    setSelectedFiles(files);
  };

  const handleUpload = async () => {
    const formData = new FormData();
    selectedFiles.forEach((file) => {
      formData.append('files', file);
    });

    await axios.post('/allowance', formData);
  };

  return (
    <div>
      <DropzoneArea
        onChange={handleFiles}
        dropzoneText="엑셀파일 업로드"
        acceptedFiles={[
          'text/xml',
          'application/xml',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet ',
        ]}
      />
      <Button
        variant="contained"
        color="primary"
        startIcon={<CloudUploadIcon />}
        onClick={handleUpload}>
        선택된 파일 업로드
      </Button>
    </div>
  );
};

export default InsuranceScreen;
